import { Component, HostListener } from '@angular/core';


export class SkyRadioLabelComponent {
  // When clicking on a checkbox label, angular registers two click events.
  // This handler ignores all events except for those that deal with the checkbox input explicitly.
  
  public onClick(event: MouseEvent) {
    event.stopPropagation();
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-radio-label',
  template: `<ng-content></ng-content>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'onClick': [{ type: HostListener, args: ['click', ['$event'], ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
